module.exports = __webpack_public_path__ + "img/monk.4c62edfe.png";